// extracted by mini-css-extract-plugin
export default {"label":"styles_label__XQB48","link":"styles_link__CWLQe"};